import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=7970b510&"
import script from "./baseLayout.vue?vue&type=script&lang=js&"
export * from "./baseLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports